import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['past', 'future'];
  static values = { today: String };

  checkDate = (event) => {
    const today = this.beginningOf(
      this.todayValue ? this.parseLocalDate(this.todayValue) : new Date(),
    );
    const enteredDate = this.beginningOf(new Date(event.target.value));
    if (enteredDate < today) {
      this.pastTarget.hidden = false;
    } else {
      this.pastTarget.hidden = true;
    }

    const tooFarInFuture = today;
    tooFarInFuture.setDate(today.getDate() + 30);
    if (enteredDate > tooFarInFuture) {
      this.futureTarget.hidden = false;
    } else {
      this.futureTarget.hidden = true;
    }
  };

  parseLocalDate = (isoDateString) => {
    const [year, month, day] = isoDateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  beginningOf = (date) => {
    const beginning = new Date(date);
    beginning.setHours(0, 0, 0, 0);
    return beginning;
  };
}
